var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "03yaqrjcra",
    d: "M0 0L38 0 38 25 0 25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6rkvt94exb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#03yaqrjcra"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M37.333 5.648L31.223.091l-.1-.091c-.225.41-.472.807-.737 1.19l5.43 4.94h-4.041v16.21c0 .71-.62 1.287-1.381 1.287h-6.56v-6.904c0-1.492-1.237-2.702-2.762-2.702h-4.143c-1.526 0-2.763 1.21-2.763 2.702v6.904h-6.56c-.761 0-1.38-.577-1.38-1.287V6.13H2.182l5.43-4.939C7.35.807 7.103.41 6.877 0c-.032.03-.068.063-.1.09L.667 5.649c-1.12 1.02-.794 1.853.725 1.853h3.453v14.84C4.844 23.808 6.081 25 7.606 25h7.941v-8.277c0-.733.62-1.33 1.382-1.33h4.143c.761 0 1.38.597 1.38 1.33V25H30.394c1.526 0 2.763-1.19 2.763-2.66V7.501h3.452c1.52 0 1.846-.834.725-1.853",
    mask: "url(#6rkvt94exb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#11CEEF",
    d: "M29.611 12.5c0 6.126-4.985 11.111-11.111 11.111-6.127 0-11.111-4.985-11.111-11.111 0-6.127 4.984-11.111 11.11-11.111 6.127 0 11.112 4.984 11.112 11.111M6 12.5C6 19.403 11.597 25 18.5 25S31 19.403 31 12.5 25.403 0 18.5 0 6 5.597 6 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M19.8 13.114c.154.045.307.094.456.151.974.375 1.418 1.52.733 2.398-.28.359-.71.572-1.19.661v-3.21zm-1.6-2.157c-.483-.14-.922-.349-1.184-.8-.486-.843.308-1.722 1.052-1.951.042-.013.087-.021.132-.032v2.783zm0-6.118v1.735c-.14.02-.28.05-.414.089-1.133.326-2.194 1.07-2.455 2.319-.182.871-.089 1.876.517 2.556.612.687 1.5.953 2.352 1.182v3.484c-.5-.164-.942-.438-1.205-.806-.271-.381-.373-.861-.664-1.23-.318-.403-.99-.472-1.235.032-.187.383-.071.937.092 1.31.11.252.249.504.402.733.593.887 1.472 1.414 2.61 1.584v1.334c0 .463.357.839.8.839.441 0 .8-.376.8-.839v-1.322c.656-.094 1.293-.316 1.853-.69.681-.454 1.217-1.192 1.318-2.035.193-1.628-.714-3.003-2.215-3.46-.317-.097-.636-.196-.956-.291V8.236c.284.087.551.21.775.375.385.284.641.725.812 1.172.13.34.374.712.74.803.376.094.798-.15.857-.567.075-.532-.114-1.128-.577-1.82-.286-.428-.635-.772-1.035-1.023-.48-.3-1.018-.482-1.572-.574V4.84C19.8 4.376 19.44 4 19 4c-.443 0-.8.376-.8.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9);
export default __webpack_public_path__ + "static/media/group-9.67102b14c6b95205740c95d8ebdca87c.svg";
export { ForwardRef as ReactComponent };